import { GebeurtenisId } from './model/gebeurtenis';

export function validateGebeurtenisId(id: string | null): GebeurtenisId {
  if (id === null) {
    throw Error('Id cannot be null');
  }

  return id as GebeurtenisId;
}
